import { createAction } from '@reduxjs/toolkit';
import {
  HOTEL_HOVERED,
  SHOW_MORE,
  PAGINATION_SUCCESS,
  SET_CURRENT_VISIBLE_HOTELS,
} from './constants';
import type { ActiveHotelState } from '../map/types';

export const hotelHoverAction = createAction<ActiveHotelState>(HOTEL_HOVERED);

export const showMoreAction = () => ({
  type: SHOW_MORE,
});

export const paginationSuccessAction = (payload) => ({
  type: PAGINATION_SUCCESS,
  payload,
});
export const setCurrentVisibleHotelsAction = (payload) => ({
  type: SET_CURRENT_VISIBLE_HOTELS,
  payload,
});
